import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { GenericTooltip } from "@components/v2/tooltips/tooltip-container";

interface Props {
  title: string;
  value: boolean;
  className?: string;
  onChange: (val: boolean) => void;
}

export const IndexCheckbox = ({ title, value, className, onChange }: Props) => {
  return (
    <GenericTooltip
      noInfoCircle
      placement="top"
      content={
        <div className="w-52">
          <div className="flex items-center justify-center mb-4">
            <div
              className={clsx(
                "w-9 h-9 rounded-full border-2 border-v2-action-positive-hover",
                "bg-v2-action-positive flex items-center justify-center",
              )}
            >
              <i
                className={clsx(
                  "fa-solid fa-chart-line-up text-lg drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]",
                  "text-white",
                )}
              />
            </div>
          </div>
          <div className="font-light text-sm">
            Compare your performance to the broader market with NBX —
            Northbeam’s marketing performance index.
          </div>
        </div>
      }
    >
      <div
        className={twMerge(
          clsx(
            "group h-6 rounded text-2xs flex items-center gap-1.5",
            "hover:border-0 hover:px-[7px] hover:bg-v2-action-positive-hover",
            "hover:shadow-md hover:text-white",
            {
              "px-[6px] border border-v2-notice bg-v2-highlight-notice": !value,
              "text-v2-action-positive": !value,
              "px-[7px] bg-v2-action-positive text-white": value,
              "shadow-[inset_2px_2px_5px_rgba(0,0,0,0.2)]": value,
            },
          ),
          className,
        )}
        onClick={(e) => {
          e.stopPropagation();
          onChange(!value);
        }}
      >
        <div
          className={clsx(
            "w-3 h-3 rounded-sm flex items-center justify-center",
            "group-hover:border-0 group-hover:bg-v2-action-positive",
            {
              "bg-white border border-v2-action-positive": !value,
              "bg-v2-action-positive-hover": value,
            },
          )}
        >
          {value && <i className="fa-solid fa-check text-2xs" />}
        </div>
        <div
          className={clsx("font-semibold", {
            "drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]": value,
          })}
        >
          {title}
        </div>
        <i
          className={clsx("fa-solid fa-chart-line-up text-xs", {
            "drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]": value,
          })}
        />
      </div>
    </GenericTooltip>
  );
};
